import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Package } from "lucide-react";

export default function SpecsSection({ core }) {
  if (!core) return null;
  const specs = core.specs || {};
  return (
    <section data-testid="specs-section" className="py-20 md:py-28" style={{ background: "var(--surface-2)", borderTop: "1px solid var(--border)", borderBottom: "1px solid var(--border)" }}>
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="eyebrow">Under the handle</div>
          <h2 className="display mt-4" style={{ fontSize: "clamp(2rem, 4.5vw, 4rem)", color: "var(--ink)" }}>
            Features &amp; <span className="sunset-text">specifications</span>.
          </h2>
          <p className="mt-6 max-w-md text-base sm:text-lg" style={{ color: "var(--ink-soft)" }}>
            No gimmicks — just an honest spec sheet tuned for backup-power homes.
          </p>

          {Array.isArray(core.in_the_box) && core.in_the_box.length > 0 && (
            <div className="mt-10 p-6 lifted rounded-xl">
              <div className="flex items-center gap-2 text-xs uppercase tracking-widest font-mono" style={{ color: "var(--ink-soft)" }}>
                <Package size={14} color="var(--sun-orange)" /> In the box
              </div>
              <ul className="mt-4 space-y-2 text-sm" style={{ color: "var(--ink)" }}>
                {core.in_the_box.map((item) => (
                  <li key={item}>· {item}</li>
                ))}
              </ul>
            </div>
          )}

          <Link to="/products/CORE-500" data-testid="specs-pdp-cta" className="mt-8 inline-flex items-center gap-2 text-sm font-medium sunset-text py-2">
            Full product page <ArrowRight size={14} color="var(--sun-orange)" />
          </Link>
        </div>

        <div className="md:col-span-7">
          <div className="glossy rounded-2xl overflow-hidden">
            <dl>
              {Object.entries(specs).map(([k, v], i) => (
                <div
                  key={k}
                  className="grid grid-cols-2 gap-4 px-6 sm:px-8 py-4"
                  style={{ borderTop: i === 0 ? "none" : "1px solid var(--border)" }}
                >
                  <dt className="text-sm" style={{ color: "var(--ink-soft)" }}>{k}</dt>
                  <dd className="text-sm font-medium font-mono text-right sm:text-left" style={{ color: "var(--ink)" }}>{v}</dd>
                </div>
              ))}
            </dl>
          </div>
        </div>
      </div>
    </section>
  );
}
